<!--
 * @Author: Gaho
 * @Date: 2024-05-06 16:41:20
 * @LastEditors: Gaho
 * @LastEditTime: 2025-01-22 13:20:59
 * @Description: 
-->
<template>
    <div class="ring-article">
        <div class="ring-img" :style="`border: 4px solid ${ringImgBorderColor};`">
            <!-- 轮盘 -->
            <img
                src="@/assets/imgs/casino/circle/circle.svg"
                alt=""
                :style="`transform: scale(1.1) rotate(${degrees}deg);`"
            />
            <!-- 时间倒计时 -->
            <p class="ring-time" v-show="showTime">
                {{ formattedNumber }}
            </p>
            <span class="ring-label">
                {{ circleStateLabel }}
            </span>
            <div class="spin" v-show="!showTime">
                <div class="loadingio-spinner-ripple">
                    <div class="ldio">
                        <div></div>
                        <div></div>
                    </div>
                </div>
            </div>
            <span
                class="arrow-down"
                :style="`border-color: ${arrowDownColor} transparent transparent;`"
            ></span>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
export default defineComponent({
    name: 'circleBoard',
    props: {
        borderColor: {
            type: String,
            default: 'rgb(27, 34, 51)',
        },
        degrees: {
            type: Number,
            default: 1,
        },
        arrowDownColor: {
            type: String,
            default: '',
        },
        showTime: {
            type: Boolean,
            default: true,
        },
        formattedNumber: {
            type: String,
            default: '15.00',
        },
        circleStateLabel: {
            type: String,
            default: '',
        },
    },
    watch: {
        borderColor: {
            async handler(newColor){
                if (newColor){
                    // 因为过渡动画无法直接设置执行多次，所以通过延时切换的方式实现闪烁两次的效果
                    this.ringImgBorderColor = newColor;
                    await Sleep(500);
                    this.ringImgBorderColor = 'rgb(27, 34, 51)';
                    await Sleep(500);
                    this.ringImgBorderColor = newColor;
                }
            },
            immediate: true,
            deep: true
        },
    },
    data(){
        return {
            ringImgBorderColor: 'rgb(27, 34, 51)'
        }
    }
});
</script>
<style lang="scss" scoped>
.ring-article {
    align-items: center;
    display: flex;
    height: 376px;
    justify-content: space-between;
    position: relative;
    @media (max-width: 550px) {
        height: 302px;
    }
    @media (max-width: 450px) {
        height: 264px;
    }
    .ring-img {
        align-items: center;
        background-color: inherit;
        border: 4px solid transparent;
        border-radius: 50%;
        display: flex;
        height: 372px;
        justify-content: center;
        left: 50%;
        overflow: hidden;
        position: absolute;
        transform: translate(-50%);
        transform-origin: 50% 50%;
        transition: border .5s;
        width: 372px;
        will-change: transform;
        @media (max-width: 550px) {
            transform: translate(-50%) scale(0.8);
        }
        @media (max-width: 450px) {
            transform: translate(-50%) scale(0.7);
        }
        img {
            transform-origin: 50% 50%;
            will-change: transform;
            user-select: none;
            width: 100%;
        }
        .ring-time {
            color: #fff;
            font-size: 48px;
            font-style: normal;
            font-weight: 600;
            left: 50%;
            line-height: 56px;
            position: absolute;
            top: 50%;
            transform: translate(-50%, -50%);
            width: 100px;
        }
        .ring-label {
            bottom: 110px;
            color: #5b6773;
            font-size: 15px;
            font-weight: 600;
            left: 50%;
            position: absolute;
            text-align: center;
            text-transform: uppercase;
            transform: translate(-50%);
        }
        .spin {
            left: 50%;
            position: absolute;
            top: 50%;
            transform: translate(-50%, -50px);
            z-index: 1;
            .loadingio-spinner-ripple {
                display: block;
                height: 81px;
                overflow: hidden;
                width: 81px;
                .ldio {
                    backface-visibility: hidden;
                    height: 100%;
                    position: relative;
                    transform: translateZ(0) scale(0.81);
                    transform-origin: 0 0;
                    width: 100%;
                    div {
                        animation: ldio 2s cubic-bezier(0, 0.2, 0.8, 1) infinite;
                        border-radius: 50%;
                        border-style: solid;
                        border-width: 5px;
                        opacity: 1;
                        position: absolute;
                        box-sizing: content-box;
                        &:first-child {
                            border-color: #fa305c;
                        }
                        &:nth-child(2) {
                            animation-delay: -1s;
                            border-color: #1bb83d;
                        }
                    }
                }
            }
        }
        .arrow-down {
            border-style: solid;
            border-width: 19px 14.5px 0;
            bottom: 176px;
            height: 0;
            position: absolute;
            right: -28px;
            transform: translate(-50%) rotate(90deg);
            width: 0;
        }
    }
}

@keyframes ldio {
    0% {
        height: 0;
        left: 45px;
        opacity: 1;
        top: 45px;
        width: 0;
    }

    to {
        height: 75px;
        left: 7.5px;
        opacity: 0;
        top: 7.5px;
        width: 75px;
    }
}
</style>